export default __webpack_public_path__ + "static/1480-38a4d9e2a2240e63f0b9c84579f1248a.gif";